import React from 'react';
import ImprintContent from '../Components/Imprint/ImprintContent';
import SEO from '../Components/SEO/SEO';
import Spacing from '../Components/Spacing/Spacing';
import { useLanguage } from '../contexts/LanguageContext';

const ImprintPage = () => {
  const { t } = useLanguage();
  
  return (
    <>
      <SEO
        title={t('imprint.meta.title')}
        description={t('imprint.meta.description')}
        image="/images/logo.svg"
      />
      <Spacing lg={120} md={80} />
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <ImprintContent />
          </div>
        </div>
      </div>
      <Spacing lg={120} md={80} />
    </>
  );
};

export default ImprintPage;
